export const WEB_MOBILE_FRAME_WIDTH = 430
